import { useQuery } from "@tanstack/react-query";
import { getLongPostponeList } from "apis/member/long_postpone_api";
import CardFixed from "components/Card/CardFixed";
import {
  generateObjectZeroId,
  getPermission,
  simpleAlert,
  SubLine,
} from "components/CommonLib/CommonLib";
import Loading from "components/Loading/Loading/Loading";
import NormalBtn from "components/NewButton/NormalBtn";
import _ from "lodash";
import { globalModalOff } from "modules/actions/Modal";
import { branch_search_init_state } from "pages/CommonModal/Search/Module/reducers/hq_branch_search_init_state";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLongPostponeStore } from "./modules/store/longPostponeState";
import LongPostponeResultTable from "./ResultTable/LongPostponeResultTable";
import DetailCondition from "./SearchCondition/DetailCondition";
import MemberInfoCondition from "./SearchCondition/MemberInfoCondition";

const LongPostponeListContent = () => {
  const storesDispatch = useDispatch();
  // 전역 상태 관리
  const {
    longPostponeSearchParams: searchParams,
    setSearchParams,
    longPostponePage: page,
    setPage,
    resetSearchParams,
  } = useLongPostponeStore();

  // 페이지 상태 관리
  const [branchList, setBranchList] = useState(_.cloneDeep(branch_search_init_state));
  const [searchResult, setSearchResult] = useState([]);
  const [totalPage, setTotalPage] = useState(1);
  const [resetFlag, setResetFlag] = useState(false);

  // 지점 권한 받아오기
  useEffect(() => {
    getPermission(storesDispatch, "SEARCH_MEMBER_MENU/SEARCH_MANAGE", true, true).then((res) => {
      setBranchList(res);
      if (
        res.branch_list.length > 0 &&
        searchParams.branch_info.branch_id === generateObjectZeroId()
      ) {
        setSearchParams("branch_info", res.branch_list[0]);
      }
    });
  }, []);

  // API 상태 관리
  const [isGetLongPostponeList, setIsGetLongPostponeList] = useState(false);
  const queryData = { page: page, searchParams: searchParams };

  // [GET] 장기연기 리스트 가져오기
  const { isFetching, data: longPostponeList } = useQuery({
    queryKey: ["longPostpone", queryData],
    queryFn: () => getLongPostponeList(queryData),
    enabled: isGetLongPostponeList,
    retry: false,
    cacheTime: 0,

    onSuccess: (res) => {
      if (res.data.msg) {
        simpleAlert(storesDispatch, "알림", res.data.msg);
      }
    },
    onError: (err) => {
      simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
    },
    onSettled: () => {
      setIsGetLongPostponeList(false);
    },
  });

  /** isExcel: 엑셀 다운로드 여부, page: 페이지네이션 */
  const onClickSearch = async (isExcel, page) => {
    setPage(page);
    // setIsExcel(isExcel);
    // 장기연기 리스트 받아오기
    setIsGetLongPostponeList(true);
  };

  const onModalDone = (res) => {
    // console.log(res);
    storesDispatch(globalModalOff());
  };

  const openModal = (order, param) => {
    // let Modal;
    // if (order === "save") {
    //   Modal = <SaveConditionModal modalParam={param} onModalDone={onModalDone} />;
    // } else if (order === "load") {
    //   Modal = <LoadConditionModal modalParam={param} onModalDone={onModalDone} />;
    // }
    // storesDispatch(
    //   globalModalOn({
    //     show: true,
    //     title: param.title,
    //     Content: Modal,
    //   }),
    // );
  };

  // API 받아온 데이터 세팅
  useEffect(() => {
    // 장기연기 리스트
    if (longPostponeList) {
      setSearchResult(longPostponeList.data.data);
      setTotalPage(longPostponeList.data.total_page);
    }
  }, [longPostponeList]);

  // 첫 페이지 진입 시 검색 결과를 가져오기
  useEffect(() => {
    setIsGetLongPostponeList(true);
  }, []);

  return (
    <CardFixed
      midDom={
        <div>
          {isFetching && <Loading />}

          <div>
            <MemberInfoCondition
              searchParams={searchParams}
              setSearchParams={setSearchParams}
              onClickSearch={onClickSearch}
            />
            <DetailCondition
              searchParams={searchParams}
              setSearchParams={setSearchParams}
              branchList={branchList}
              resetFlag={resetFlag}
              onClickSearch={onClickSearch}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "0.75rem",
                gap: "0.25rem",
              }}
            >
              <NormalBtn
                theme="white"
                name="초기화"
                search
                onClick={() => {
                  resetSearchParams();
                  setResetFlag(!resetFlag);
                }}
              />

              <NormalBtn
                name="검색"
                search
                onClick={() => {
                  onClickSearch(false, 1);
                }}
              />
            </div>
          </div>

          <SubLine />

          <div style={{ marginTop: "1rem" }}>
            <LongPostponeResultTable
              searchResult={searchResult}
              curPage={page}
              totalPage={totalPage}
              onClickSearch={onClickSearch}
            />
          </div>
        </div>
      }
      isLoading={false}
      rootStyle={
        {
          // width: "80.437rem",
          // height: "74.875rem",
        }
      }
    />
  );
};
export default LongPostponeListContent;
